export default "__VITE_PUBLIC_ASSET__c472c923__"